<div *ngIf="data.title" class="card-title dialog-title">
  <h3 mat-dialog-title>
    {{ data.title }}
  </h3>
  <button mat-icon-button mat-dialog-close>
    <mat-icon> close </mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="message-image mb-md-4" *ngIf="data.image">
    <img [src]="data.image" />
  </div>
  <div [className]="alignText" [innerHTML]="data.message"></div>
</mat-dialog-content>
<mat-dialog-actions [attr.align]="alignButtons" class="mt-md-4 mb-4 pb-0">
  <ng-container *ngFor="let btn of data.buttons">
    <button
      *ngIf="btn.type === 'secondary'; else defaultButton"
      class="ml-2"
      mat-stroked-button
      [mat-dialog-close]="btn.value"
    >
      {{ btn.text }}
    </button>
    <ng-template #defaultButton>
      <button
        mat-flat-button
        [mat-dialog-close]="btn.value"
        class="ml-2"
        color="primary"
      >
        {{ btn.text }}
      </button>
    </ng-template>
  </ng-container>
</mat-dialog-actions>
